import React from 'react';
export function Footer() {
  return <footer className="bg-brand-text text-brand-card py-12 sm:py-16 px-4 text-center" data-id="element-70">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-4" data-id="element-71">
        <img src="https://cdn.magicpatterns.com/uploads/csnKSKWxgJ7EjkLSDSPn4V/LOGO_DECOEMPRENDE.png" alt="Deco Emprende" className="h-16 sm:h-20 object-contain brightness-0 invert opacity-90 mb-2" data-id="element-72" />
        <h3 className="font-serif text-xl sm:text-2xl text-brand-warm" data-id="element-73">
          Deco Emprende — Deco Tricotín
        </h3>
        <p className="text-brand-card/60 text-xs sm:text-sm uppercase tracking-widest font-medium" data-id="element-74">
          Producto digital · Descarga inmediata
        </p>
        <div className="w-12 h-px bg-brand-card/20 my-4" data-id="element-75" />
        <p className="text-brand-card/40 text-xs sm:text-sm" data-id="element-76">
          © {new Date().getFullYear()} Deco Emprende — Deco Tricotín. Todos los
          derechos reservados.
        </p>
      </div>
    </footer>;
}